interface SortableHeaderProps {
  label: string;
  /** Omit to render a plain, non-sortable header. */
  field?: string;
  sortColumn: string;
  sortDirection: string;
  onSort: (field: string) => void;
}

const SortableHeader = ({
  label,
  field,
  sortColumn,
  sortDirection,
  onSort,
}: SortableHeaderProps) => {
  if (!field) return <th>{label}</th>;

  const active = sortColumn === field;

  return (
    <th
      className="is-sortable"
      aria-sort={
        active ? (sortDirection as "ascending" | "descending") : "none"
      }
    >
      {/* A real button so Enter, Space and focus work; aria-sort on the th
          would otherwise advertise sorting a keyboard user cannot trigger. */}
      <button
        type="button"
        className="admin-report__sort-button"
        onClick={() => onSort(field)}
      >
        {label}
        <span aria-hidden="true" className="admin-report__sort-arrow">
          {active ? (sortDirection === "ascending" ? "▲" : "▼") : "⇅"}
        </span>
      </button>
    </th>
  );
};

export default SortableHeader;
